import { CircularProgress, Dialog, Grid, Typography } from "@mui/material";
import * as React from "react";
const SliderProgress = ({
  open,
  mensaje,
}: {
  open: boolean;
  mensaje?: string;
}) => {
  return (
    <Dialog
      fullScreen
      className="ContainerSliderProgress"
      sx={{ zIndex: 2000 }}
      open={open}
      BackdropProps={{
        style: {
          backgroundColor: "transparent",
        },
      }}
    >
      <Grid
        className="containerCenter"
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <Grid
          item
          container
          justifyContent="center"
          direction="column"
          alignItems="center"
        >
          <CircularProgress
            size={200}
            sx={{
              color: "#15212f",
            }}
          />
        </Grid>
        <Grid
          item
          container
          justifyContent="center"
          direction="column"
          alignItems="center"
          paddingTop={2}
        >
          <Typography variant="h4" className="Cargando">
            {mensaje ? mensaje : "Cargando .."}
          </Typography>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default SliderProgress;
